import { RefObject, useEffect } from "react";

// Issue #759 (final review F6): aria-hidden alone does not reliably remove an element's
// descendants from the tab order (browser support for that has historically been inconsistent),
// so a sighted keyboard user could still Tab into stale content hidden behind the
// connection-lost overlay and activate it. The HTML `inert` attribute is the browser-native way
// to both remove a subtree from the tab order and block pointer interaction with it.
//
// Note: passing `inert` as a JSX prop (even `{...{ inert: true } as any}`) is silently dropped by
// this project's React/ReactDOM version (18.3.1) - it never reaches the DOM as an attribute. It
// must be set imperatively via ref + setAttribute/removeAttribute instead, which is what this
// hook does.
function useInert(ref: RefObject<HTMLElement>, isInert: boolean) {
    useEffect(() => {
        const el = ref.current;
        if (!el) {
            return;
        }
        if (isInert) {
            el.setAttribute('inert', '');
        } else {
            el.removeAttribute('inert');
        }
    }, [ref, isInert]);
}

export default useInert;
